import React from "react";

import CuratorialSection from "../content/CuratorialSection";
import Layout from "../components/Layout";
import Partners from "../ui/mainPage/Partners";

const CuratorialActivities = (props) => {
    const { pageContext } = props
    const { numCurators, numActivities} = pageContext
    return (
        <Layout>
            <CuratorialSection numCurators={numCurators} numActivities={numActivities} />
            <Partners />
        </Layout>
    );
};

export default CuratorialActivities;
